// extracted by mini-css-extract-plugin
export var acitonButtons = "_gp-0";
export var additionalIcon = "_gp-f";
export var block = "_gp-1";
export var blockContent = "_gp-7";
export var blockDescription = "_gp-8";
export var blockIcon = "_gp-9";
export var blockTitle = "_gp-6";
export var border = "_gp-a";
export var center = "_gp-l";
export var edge = "_gp-b";
export var edgeLabel = "_gp-c";
export var edgePath = "_gp-d";
export var error = "_gp-e";
export var flowchart = "_gp-g";
export var flowchartContent = "_gp-h";
export var highlighted = "_gp-3";
export var hover = "_gp-4";
export var icon = "_gp-i";
export var left = "_gp-m";
export var navButton = "_gp-j";
export var navButtons = "_gp-k";
export var right = "_gp-n";
export var selected = "_gp-2";
export var small = "_gp-5";